import Vue from 'vue'
import { ToastPlugin, ModalPlugin , BBreadcrumb , BBreadcrumbItem } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

//end moment to convert date
import moment from 'moment';

Vue.filter('formatDate', function(value) {
  if (value) {
      return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
});
Vue.filter('cutString', function(value) {
  if (value) {
      return value.length > 25 ? value.substring(0, 25) + '.....' : value
  }
});
Vue.filter('trimString', function(value) {
  if (value) {
      return value.replace(/(^,)|(,$)/g, "")
  }
});
//end moment to convert date

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

Vue.component('b-breadcrumb', BBreadcrumb);
Vue.component('b-breadcrumb-item', BBreadcrumbItem);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = true

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
